import { ENTITY_ITEMS_DROPDOWN_LIMIT } from '@/_legacy/constants';
import { defineComponent, h } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { SelectOptions } from '@/ui/types';
import { TagField } from '@/ui/components/form';
import { ValidationError } from '@/entities/validation';
import { VDataComponents } from '@/ui/helpers';

interface ChooseEntityFolderFieldProps {
  options: SelectOptions;
  value: number[];
  errors: ValidationError[];
  disabled?: boolean;
  required?: boolean;
  tooltipText?: string;
  name?: string;
  label?: string;
  placeholder?: string;
  identifier?: string;
  hideLabel?: boolean;
}

export const ChooseEntityFolderField = defineComponent<ChooseEntityFolderFieldProps>({
  name: 'ChooseEntityFolderField',
  props: [
    'options', 'value', 'errors', 'label', 'placeholder',
    'identifier', 'hideLabel', 'required', 'tooltipText', 'name',
  ],
  setup(props, ctx) {
    return function render() {
      return h('div', { class: 'field' }, [
        h(TagField, {
          props: {
            value: props.value,
            options: props.options,
            disabled: false,
            placeholder: props.placeholder ?? t('user.user-to-entity-folder'),
            label: props.label ?? t('common.entity-folders'),
            name: props.name || 'entityFolders',
            required: props.required,
            errors: props.errors,
            hideLabel: props.hideLabel,
            tooltipText: props.tooltipText,
            maxListedOptions: ENTITY_ITEMS_DROPDOWN_LIMIT,
            overrideErrorMessage: t('entity-folder.error.invalid_children'),
          },
          on: {
            input: (value: Array<string | number>) => ctx.emit('input', value),
          },
        }),
      ]);
    };
  },
});

export const chooseEntityFolderField = (data: VDataComponents<ChooseEntityFolderFieldProps>) => h(ChooseEntityFolderField, data);
